import { useEffect, useRef } from 'react';

import { shouldIgnorePlatformShortcut } from '@/utilities/keyboardShortcuts';

type KeyboardShortcutCallback = (event: KeyboardEvent) => void;

export const useKey = (code: string, callback: KeyboardShortcutCallback): void => {
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    });

    useEffect(() => {
        const handle = (event: KeyboardEvent) => {
            if (event.code === code && event.altKey && !shouldIgnorePlatformShortcut(event)) {
                callbackRef.current(event);
            }
        };

        document.addEventListener('keydown', handle);

        return () => document.removeEventListener('keydown', handle);
    }, [code]);
};
